(function() {
  // Add custom code below this line
  $(".product__submit__add-js-normal").click(() => {
    $(".product-form--add-to-cart").click();
  })
  
  $(".product__submit__add-js-sticky-add").click(() => {
    $(".qv-add-button").click();
  })

if(window.outerWidth > 786){
  $(".product-guaratee-block").click(() => {
    $(".product-description-block").removeClass("active-tab");
    $(".product-shipping-block").removeClass("active-tab");
    $(".product-guaratee-block").addClass("active-tab");
    
    $(".product-shipping-block_inner").hide();
    $(".product-description-block_inner").hide();
    $(".product-guaratee-block_inner").slideDown("fast");
  })

  $(".product-shipping-block").click(() => {
    $(".product-description-block").removeClass("active-tab");
    $(".product-guaratee-block").removeClass("active-tab");
    $(".product-shipping-block").addClass("active-tab");
    
    $(".product-guaratee-block_inner").hide();
    $(".product-description-block_inner").hide();
    $(".product-shipping-block_inner").slideDown("fast");
  })

  $(".product-description-block").click(() => {
    $(".product-guaratee-block").removeClass("active-tab");
    $(".product-shipping-block").removeClass("active-tab");
    $(".product-description-block").addClass("active-tab");
    
    $(".product-guaratee-block_inner").hide();
    $(".product-shipping-block_inner").hide();
    $(".product-description-block_inner").slideDown("fast");
  })
}

  

  
  /*
  $(document).ready(function() {
    // (Optional) Active an item if it has the class "is-active"	
    $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
    $(".accordion > .accordion-item").click(function() {
      // Cancel the siblings
      $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
      $(this).children(".accordion-thumb").toggleClass("is-active-thumb");
      // Toggle the item
      $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
    });
  });
  */

  
  /*$(".sticky-variants").html($(".product-form--options").html());*/




  



  
  $(".sticky-variants .radio__button").click(function() {
    let $this = $(this);
    $this.find("input").prop('checked', true);
  });
  $(".product__info-wrapper .radio__button").click(function() {
    let $this = $(this);
    $this.find("input:checked").attr("id");
    let id = $this.find("input:checked").attr("id")
    let id2 = $(".sticky-variants .radio__button input").map(function() {
      return $(this).attr('id');
    }).get();
    /*$('.sticky-variants .radio__button input').each(function(){
      var $match = $('.sticky-variants .radio__button input[id*="'+id+'"]');
       if($match.length){
           $match.prop('checked', true);
         return false; // You can stop checking .box1's now
       }
     });*/
  });

  

  $(".cart-bar-container").show();
  /*$(document).scroll(function() {
    var y = $(this).scrollTop();
    if (y > 800) {
      $('.cart-bar-container').show();
    } else {
      $('.cart-bar-container').hide();
    }
  });*/
  

  function callback(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        $(".cart-bar").fadeOut("fast");
      } else {
        $(".cart-bar").show();
      }
    });
  }
  var observer = new IntersectionObserver(callback);
  if(document.getElementById('observer_id')){
    observer.observe(document.getElementById('observer_id'));
  }

  
  $(window).scroll(function() {
    if (($('body').height()-200) <= ($(window).height() + $(window).scrollTop())) {
        document.getElementById("cart-bar").style.display= 'none'
    }else{
      var observer2 = new IntersectionObserver(callback);
      if(document.getElementById('observer_id')){
        observer2.observe(document.getElementById('observer_id'));
      }
    }
  });







  

  $('.eam-slideshow').slick({
    dots: true,
    arrows: true
});


if($('.product-form--option .disclosure--option')){
  $(document).on('click','.product-form--option .disclosure--option',function(){
          $(this).parents('.product-page--blocks').find('.product-form--button-container button').css('background', '#A9C8C8');
          $(this).parents('.product-page--blocks').find('.product-form--button-container button *').css('color', 'white');
          $(this).parents('.product-page--blocks').find('.product-form--button-container button svg path').css('fill', 'white');
  });  
}else{
  if(window.location.href.includes("products")){
    $('.product-form--button-container button').css('background', '#A9C8C8');
    $('.product-form--button-container button *').css('color', 'white');  
    $('.product-form--button-container button  svg path').css('fill', 'white');
    
  }
  
}

  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.





  // Add custom code below this line
  setInterval(function time() {
    var d = new Date();
    var hours = 24 - d.getHours();
    var min = 60 - d.getMinutes();
    if ((min + '').length == 1) {
      min = '0' + min;
    }
    var sec = 60 - d.getSeconds();
    if ((sec + '').length == 1) {
      sec = '0' + sec;
    }
    $('.timer').html(hours + 'hrs ' + min + 'm ' + sec + 's ')
      $('.timer1').html(hours + ':' + min + ':' + sec + '')
  }, 1000);



  var currentDate = new Date(new Date().getTime() + 144 * 60 * 60 * 1000);
  var day = currentDate.getDate()
  var month = currentDate.getMonth() + 1
  var year = currentDate.getFullYear()
  var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  $(".date-product").html(days[currentDate.getDay()] + " " + day + "th " + monthNames[currentDate.getMonth()])

    $(document).ready(function() {
      $(".scroll-down-button").click(function(event) {
        $('html, body').animate({
          scrollTop: '+=400px'
        }, 0);
      });
    });  
})();
 $('.embroidery_sec-image').click(function(){
     if($(this).next().css('display')=="none"){
       $(this).next().show(); 
     }else{
       $(this).next().hide(); 
     } 
  });  
if(window.outerWidth<768){
  $('.product-tabs-blocks.-mobile-main .-mobile-inner').hide();
  $('.product-overview-block.-mobile').addClass('active-tab')
  $('.product-overview-block_inner.-mobile-inner').show()
  $(document).ready(function() {
    $(".product-tabs-blocks.-mobile-main .-mobile").click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      if($(this).hasClass("active-tab")){
        $(".product-tabs-blocks.-mobile-main .-mobile").removeClass("active-tab");
        $(".product-tabs-blocks .-mobile-inner").slideUp('fast');
      }else{
        $(".product-tabs-blocks.-mobile-main .-mobile").removeClass("active-tab");
        $(".product-tabs-blocks .-mobile-inner").slideUp('fast');
        $(this).addClass("active-tab");  
        $(this).next().slideDown('fast');
      }
       
    });
  });
}
  



